import React from 'react'
import { useState } from 'react'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'


const Projects = ({openModal,setOpenModal}) => {
  const [toggle, setToggle] = useState('all');
  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
        My portfolio includes a variety of projects, including web applications, Object Oriented Programming and FiveM projects. Here are some highlights of my work.
        </Desc>
        <ToggleButtonGroup >
          {toggle === 'all' ?
            <ToggleButton active value="all" onClick={() => setToggle('all')}>All</ToggleButton>
            :
            <ToggleButton value="all" onClick={() => setToggle('all')}>All</ToggleButton>
          }
          <Divider />
          {toggle === 'web app' ?
            <ToggleButton active value="web app" onClick={() => setToggle('web app')}>WEB APP'S</ToggleButton>
            :
            <ToggleButton value="web app" onClick={() => setToggle('web app')}>WEB APP'S</ToggleButton>
          }
          <Divider />
          {toggle === 'FiveM Projects' ?
            <ToggleButton active value="FiveM Projects" onClick={() => setToggle('FiveM Projects')}>FiveM Projects'S</ToggleButton>
            :
            <ToggleButton value="FiveM Projects" onClick={() => setToggle('FiveM Projects')}>FiveM Projects'S</ToggleButton>
          }
          <Divider />
          {toggle === 'Object Oriented Programming' ?
            <ToggleButton active value="Object Oriented Programming" onClick={() => setToggle('Object Oriented Programming')}>Object Oriented Programming</ToggleButton>
            :
            <ToggleButton value="Object Oriented Programming" onClick={() => setToggle('Object Oriented Programming')}>Object Oriented Programming</ToggleButton>
          }
        </ToggleButtonGroup>
        <CardContainer>
          {toggle === 'all' && projects
            .map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
          {projects
            .filter((item) => item.category == toggle)
            .map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal}/>
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  )
}

export default Projects